import "firebase/analytics";
import "firebase/auth";
import { ReactElement, ReactNode, useReducer } from "react";

import {
  initialState,
  reducer,
  SellarContext,
} from "./useSellarContext.shared";

export const SellarContextProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <SellarContext.Provider
      value={[
        {
          ...state,
        },
        dispatch,
      ]}
    >
      {children}
    </SellarContext.Provider>
  );
};
